import { Component, Emit, Provide, Ref, Vue } from 'vue-property-decorator'
import {
    initialNotificationTemplatesModalState,
    NotificationTemplatesModalState,
    NotificationTemplatesModalType
} from '@/modules/configurationModule/detail/notifications/components/notification-templates-modal/notification-templates-modal.model'
import { ContentCustomNotificationTextTemplateGrid } from '@/modules/configurationModule/detail/notifications/components/notification-templates-grid/notifications-templates-grid.model'
import { NotificationVariableResponse } from '@/modules/configurationModule/detail/notifications/models/common'
import { customNotificationTypeService } from '@/modules/configurationModule/detail/notifications/services/custom-notification-type.service'
import { customNotificationVariablesService } from '@/api/resources/customNotifications/customNotificationVariablesService'
import { BModal } from 'bootstrap-vue'

@Component
export default class NotificationTemplatesModal extends Vue {
    @Ref() readonly notificationTemplatesModal!: BModal
    @Ref() readonly notificationBodyTextInput!: any
    @Provide() externalValidator = this.$validator
    @Emit()
    update(notificationTemplate: NotificationTemplatesModalState): NotificationTemplatesModalState {
        return {
            id: this.state.id,
            ...notificationTemplate
        }
    }
    @Emit()
    create(notificationTemplate: NotificationTemplatesModalState): NotificationTemplatesModalState {
        return notificationTemplate
    }

    state: NotificationTemplatesModalState
    constructor() {
        super()
        this.state = initialNotificationTemplatesModalState()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }
    get modelValidated(): boolean {
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors
    }

    get actionTitle(): string {
        return this.state.id ? this.$t('configuration.actions.update').toString()
            : this.$t('configuration.actions.add').toString()
    }

    async show(selectedRow: ContentCustomNotificationTextTemplateGrid | null): Promise<void> {
        await this.initializeNotificationTemplate(selectedRow)
        this._showModal()
    }

    async onTemplateTypeSelect(templateType: NotificationVariableResponse): Promise<void> {
        this.state.allowedVariables = await this.getAllCustomNotificationAllowedVariables(templateType.code)
    }

    onAllowedVariablesBadgeClick(allowedVariable: string): void {
        const variable = `{{${allowedVariable}}}`
        this.notificationBodyTextInput.insertTextAtCaretPosition(variable)
        this.$nextTick(() => {
            this.notificationBodyTextInput.focus()
        })
    }

    async initializeNotificationTemplate(notificationTemplate: ContentCustomNotificationTextTemplateGrid | null): Promise<void> {
        this.state = initialNotificationTemplatesModalState()
        await this.$validator.reset()
        if (notificationTemplate) {
            const allowedVariables = await this.getAllCustomNotificationAllowedVariables(notificationTemplate.type.code)
            this.state = {
                allowedVariables,
                id: notificationTemplate.id,
                active: notificationTemplate.active,
                text: notificationTemplate.text,
                title: notificationTemplate.title,
                type: notificationTemplate.type
            }
        }
    }

    get templateTypeSelectDisabled(): boolean {
        return !!this.state.id
    }

    get laboratoryId(): number {
        return this.$store.getters.labId
    }

    async getAllCustomNotificationAllowedVariables(code: string): Promise<NotificationVariableResponse[]> {
        const response =
            await this.$_toCallSecure(
                customNotificationVariablesService.getAllCustomNotificationVariablesByNotificationType(code))
        return response ?? []
    }
    async getAllCustomNotificationTypes(): Promise<NotificationTemplatesModalType[]> {
        const response =
            await this.$_toCallSecure(
                customNotificationTypeService.getCustomNotificationTypes())
        return response ?? []
    }

    actionModal(): void {
        if (this.state?.id) {
            this.update(this.state)
        } else {
            this.create(this.state)
        }
    }

    private _showModal(): void {
        this.notificationTemplatesModal.show()
    }

    hide(): void {
        this.notificationTemplatesModal.hide()
    }
}
